import { Component, OnInit, Input, ViewChild, TemplateRef, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';



@Component({
  selector: 'privacy',
  templateUrl: './privacy.html',
  styleUrls: ['./privacy.css']
})
export class Privacy {
  constructor(private route: ActivatedRoute) { }
}



// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/privacy/privacy.ts